import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames'

const propTypes = {
  isOnboardingFinished:   PropTypes.bool.isRequired,
  hasUnreadNotifications: PropTypes.bool.isRequired,
  imageUrl:               PropTypes.string.isRequired,
  onClick:                PropTypes.func.isRequired,
}

const HeaderNotificationsNav = ({ isOnboardingFinished, hasUnreadNotifications, imageUrl, onClick }) => {
  const notificationClasses = () => {
    return classNames(
      'notifications',
      {'_newNotifications': hasUnreadNotifications},
      {'_displayNone':      !isOnboardingFinished},
    )
  }
  return (
    <nav className='ds-navigation -header'>
      <div className='header-box'>
        <i className='materialIcon --xxsmall'>add_circle</i>
        <p className='headline -darkBlue'>Apply Now</p>
      </div>
      <a className={notificationClasses()} onClick={onClick} data-testid='notifications-bell'>
        <img src={imageUrl} alt='notifications' />
      </a>
    </nav>
  );
}

HeaderNotificationsNav.propTypes = propTypes;
export default HeaderNotificationsNav;



// WEBPACK FOOTER //
// ./src/features/applyNow/components/HeaderNotificationsNav.js